import React from "react";
import { useSettings } from "../../lib/useSettings";
import { Icon } from "../../lib/icons";

const FALLBACK_ITEMS = [
  { icon: "Shield", title: "Garantie décennale", desc: "Toutes nos installations sont couvertes 10 ans." },
  { icon: "Sparkles", title: "Marques premium", desc: "Nous installons uniquement des marques partenaires reconnues pour leur qualité." },
  { icon: "Users", title: "Équipe experte", desc: "Notre équipe expérimentée à votre service." },
  { icon: "Award", title: "Travail soigné", desc: "Un travail de qualité, professionnel et reconnu par nos clients." },
];

export default function Differenciation() {
  const { settings: s } = useSettings();

  const kicker = s?.differentiation_kicker || "Pourquoi nous";
  const title = s?.differentiation_title || "Un artisan local qui tient parole.";
  const text = s?.differentiation_text || "Nous mettons notre expertise au service de nos clients particuliers et professionnels avec un engagement constant sur la qualité et la proximité.";
  const badge = s?.differentiation_badge_text || "Chauffage · Plomberie · Climatisation";
  const items = (s?.why_choose_us && s.why_choose_us.length > 0) ? s.why_choose_us : FALLBACK_ITEMS;
  const badgeIcons = (s?.differentiation_badge_icons && s.differentiation_badge_icons.length > 0)
    ? s.differentiation_badge_icons
    : ["Flame", "Droplets"];

  // Split title to apply gradient on last "important" word like original (em)
  const renderTitle = () => {
    // If title contains "<em>word</em>" or similar, or a pipe "|", split visually
    const parts = title.split("|").map(p => p.trim());
    if (parts.length >= 2) {
      return (
        <>
          {parts[0]}<br/>
          <em className="not-italic brand-gradient-text">{parts.slice(1).join(" ")}</em>
        </>
      );
    }
    return title;
  };

  return (
    <section className="py-20 md:py-24 bg-white" data-testid="differenciation-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
          <div>
            <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-[color:var(--brand-red)] font-semibold mb-3">{kicker}</div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[color:var(--brand-navy)] leading-tight">
              {renderTitle()}
            </h2>
            <p className="mt-6 text-[hsl(var(--muted-foreground))] text-base md:text-lg leading-relaxed max-w-md">
              {text}
            </p>
            <div className="mt-8 flex items-center gap-3">
              <div className="flex -space-x-2">
                {badgeIcons.slice(0, 4).map((iconName, i) => {
                  const colors = [
                    "bg-[color:var(--brand-red)]/10 text-[color:var(--brand-red)]",
                    "bg-[color:var(--brand-sky)]/10 text-[color:var(--brand-sky)]",
                    "bg-[color:var(--brand-navy)]/10 text-[color:var(--brand-navy)]",
                    "bg-emerald-100 text-emerald-600",
                  ];
                  return (
                    <span key={i} className={`w-10 h-10 p-2 rounded-full flex items-center justify-center ${colors[i % colors.length]}`}>
                      <Icon name={iconName} className="w-full h-full" />
                    </span>
                  );
                })}
              </div>
              <div className="text-xs text-[hsl(var(--muted-foreground))] uppercase tracking-wider font-semibold">
                {badge}
              </div>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {items.map((it, i) => (
              <div key={i} className="group p-6 rounded-2xl bg-[hsl(var(--muted))]/40 hover:bg-[color:var(--brand-navy)] hover:text-white transition-all shadow-hover cursor-default">
                <Icon name={it.icon || "Shield"} className="w-7 h-7 text-[color:var(--brand-sky)] group-hover:text-white mb-4" />
                <h3 className="font-display font-bold text-lg mb-1">{it.title}</h3>
                <p className="text-sm opacity-80 leading-relaxed">{it.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
